import {ReactNode, useState} from 'react';
import {view} from '@sail/ui';
import {TopBar} from '../TopBar';
import {Title} from './Title';
import {Description} from './Description';
import {UserInfo} from './UserInfo';
import {Codes} from './Codes';

type Props = {
  userName: string;
  userPhoneNumber: string;
  userCode: string;
  agentCode: string;
  error?: ReactNode;
  loading?: boolean;
};

const Details = ({
  userName,
  userPhoneNumber,
  userCode,
  agentCode,
  error,
  loading,
}: Props) => (
  <>
    <Description />
    <UserInfo userName={userName} userPhoneNumber={userPhoneNumber} />
    <Codes
      userCode={userCode}
      agentCode={agentCode}
      error={error}
      loading={loading}
    />
  </>
);

export const RequestACallTopBar = ({
  userName,
  userPhoneNumber,
  userCode,
  agentCode,
  error,
  loading,
}: Props) => {
  const [showDetails, setShowDetails] = useState<boolean>(true);

  return (
    <TopBar data-testId="widget-request-a-call">
      <view.div css={{stack: 'y'}}>
        <Title
          showDetails={showDetails}
          onToggle={() => setShowDetails(!showDetails)}
        />
        {showDetails ? (
          <Details
            userName={userName}
            userPhoneNumber={userPhoneNumber}
            userCode={userCode}
            agentCode={agentCode}
            error={error}
            loading={loading}
          />
        ) : null}
      </view.div>
    </TopBar>
  );
};
